<template>
  <div class="share-layout">
    <slot />
  </div>
</template>

<style>
.share-layout {
  min-height: 100vh;
  width: 100%;
}
</style> 